<template>
    <div class="page wallet">
      <pageTitle title='储值卡修改密码' />
      <inputBox hintMsg='请输入手机号' :disabled='true' label='手机号' v-model='userInfo.sjno' />
      <inputBox hintMsg='请设定支付密码' :secret='true' label='新密码' v-model='passwordnew' />
      <inputBox hintMsg='请再输入一次' :secret='true' label='确认密码' v-model='passwordcheck' />
      <inputBox hintMsg='请输入附加码' label='附加码' v-model='validCode' extendType='icon' :extendSrc='TPFJM' @extendHandler='getValidateCode'/>
      <inputBox hintMsg='请输入验证码' label='手机验证码' v-model='phoneCode' extendType='button' extendSrc="获取验证码" :countDownSeconds='countDown' @extendHandler='getYZM'/>
      <mu-raised-button label="修 改" primary @click="change" v-bind:style="{ width:'96%',height:'50px',margin:'2%', }" />
      <mu-toast id="alertline" v-if="toast" v-bind:message="TellUser" @close="hideToast" />
    </div>
</template>

<style lang="less">
.page {
    .form {
        div.relative {
            position: relative;
        }
        div {
            border-bottom: 1px solid #F1F1F1;
            padding: 15px;
            padding-top: 15px;
            height: 60px;
            label {
                font-weight: bold;
                width: 25%;
                display: inline-block;
                font-size: 0.3rem;
                color: #333;
            }
            input {
                width: 70%;
                border: none;
                height: 35px;
                font-size: 14px;
            }
            input:focus {
                border: none;
                outline: medium;
            }
        }
        div:last-child {
            position: relative;
            margin-bottom: 15px;
            .valid {
                width: 150px;
                height: 35px;
                padding-top: 5px;
                border: none;
                position: absolutely;
                left: 70%;
                top: -35px;
                font-size: 14px;
                a {
                    color: #666;
                }
            }
        }
    }
}
</style>

<style lang="less" scoped>
.page {
    background-color: white;
}
</style>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import { } from '../../utils/valid.js'
export default {
    data() {
        return {
            passwordnew: '',
            passwordcheck: '',
            validCode: '',
            phoneCode: '',
            toast: false,
            TellUser: '',
            TPFJM: '',
            countDown: 0,
            demo:''

        }
    },
    activated() {
        this.passwordnew ='';
        this.passwordcheck ='';
        this.validCode ='';
        this.phoneCode ='';

    },
    created() {
        this.getValidateCode();
    },
    methods: {
        change() {
            //验证    
            if (this.valid()) {
                var params = new this.URLSearchParam();
                params.append('phone', this.userInfo.sjno);
                params.append('firstPassword', this.passwordnew);
                params.append('secondPassword', this.passwordcheck);
                params.append('smsVerification', this.phoneCode);
                this.$http.post(api.resetStoredCardPassword(), params.toParam()).then((res) => {
                    if (res.Result) {
                        this.TellUser = res.Data;
                        this.showToast();

                        setTimeout(() => { this.$router.push({ path: '/wallet/valueCardDetail' }) }, 1500);

                    }
                    else {
                        this.TellUser = res.Message;
                        this.showToast();
                    }
                })
            }
            else{
              this.showToast()
            }
        },
        showToast() {
            this.toast = true
            if (this.toastTimer) clearTimeout(this.toastTimer)
            this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
        },
        hideToast() {
            this.toast = false
            if (this.toastTimer) clearTimeout(this.toastTimer)
        },
        // 图片验证码
        getValidateCode() {
            // 用户已登录
            if (!this.userInfo.Card_no) {
                this.$router.push({ path: '/user/UserCenter' });
            }
            this.TPFJM = api.getValidateCode();
        },
        valid() {
            if (this.passwordnew == '' || this.passwordnew == null) {
                this.TellUser = "请输入新密码！";
                return false;
            }
            else if (this.passwordnew != this.passwordcheck) {
                this.TellUser = "两次密码不一致！";
                return false;
            }
            else if (this.validCode == null || this.validCode == '') {
                this.TellUser = "请输入图形验证码！";
                return false;
            }
            else if (this.phoneCode == null || this.phoneCode == '') {
                this.TellUser = "请输入手机验证码！";
                return false;
            }
            else {
                return true;
            }
        },
        //  获取验证码
        getYZM() {
            if (this.validCode == '' || this.validCode == null) {
                this.TellUser = "请输入图形验证码！";
                this.showToast();
                this.countDown = 0
            }
            else {
                this.countDown = 30
                var params = new this.URLSearchParam();
                params.append('templateName', 'PwdReset');
                params.append('captcha', this.validCode);
                this.$http.post(api.sendSMSCode(), params.toParam()).then((res) => {
                    if (res.Result == true) {
                        
                        this.TellUser = res.Data;
                        this.showToast();

                    }
                    else {  // 
                        this.getValidateCode();
                        this.TellUser = res.Message;
                        this.showToast();

                        this.countDown = 5
                    }

                })
            }
        },

    },
    computed: {
        ...mapGetters({
            userInfo: 'g_UserInfo'
        }),
    },
}
</script>


// WEBPACK FOOTER //
// valueCardPwdReset.vue?dce66d70